
<template>
  <div class="searchResult" :class="{ isIosx: isIosx, noAppNav: !isToken }">
    <div class="searchResultNav" id="searchResultNav">
      <img
        class="navLeft"
        @click="prev()"
        src="./../../assets/school/backh.png"
      />
      <div class="navMid">
        <img src="./../../assets/school/seach1.png" alt="" />
        <van-field
          v-model="title"
          :border="false"
          :clearable="true"
          placeholder="请输入想要搜索的课程"
          @focus="getFocus()"
        />
      </div>
      <span class="navRight" @click="toSearch()">搜索</span>
    </div>
    <!-- 内容 -->
    <div class="searchResultMid">
      <van-tabs
        line-width="16px"
        line-height="4px"
        title-inactive-color="#6E727A"
        title-active-color="#404247"
        v-model="searchActive"
        @change="tabChange"
        ref="tabs"
        sticky
        :offsetTop="offsetTop"
      >
        <van-tab
          v-for="(item, index) in navList"
          :key="index"
          :title="item.title"
        >
          <div class="searchResultList" v-if="loaded">
            <!-- 有数据 -->
            <div v-if="dataList.length > 0">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <CourseColum
                    :dataList="dataList"
                    v-if="showType"
                  ></CourseColum>
                  <CourseRow :dataList="dataList" v-else></CourseRow>
                </van-list>
              </van-pull-refresh>
            </div>
            <!-- 无数据 -->
            <div v-else class="noData">
              <img src="./../../assets/school/404.png" />
              <p>没有找到相关课程～</p>
            </div>
          </div>
          <div v-else class="load">
            <img src="./../../assets/school/loading.gif" />
            <p>加载中</p>
          </div>
        </van-tab>
      </van-tabs>
      <!-- 筛选条件 -->
      <div class="seccontentTop">
        <div>
          <div>
            <!-- <van-dropdown-menu active-color="#4E7DF7">
                <van-dropdown-item
                  :title="dropdownTitle"
                  get-container="body"
                  ref="dropdown1"
                >
                  <ul class="dropdownMenu">
                    <li
                      class="dropdownItem"
                      :class="{ dropdownItemCheck: item.check }"
                      v-for="(item, index) in dropdownOption"
                      :key="index"
                      @click="choice(item.value, item.text)"
                    >
                      {{ item.text }}
                    </li>
                  </ul>
                </van-dropdown-item>
              </van-dropdown-menu> -->
          </div>
          <span @click="changeShowType()">
            <img src="./../../assets/school/morerow.png" v-if="showType" />
            <img src="./../../assets/school/singlerow.png" v-else />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CourseColum from "./components/courseColumn.vue";
import CourseRow from "./components/courseRow.vue";
export default {
  data() {
    return {
      needRefresh: true, //判断页面是否需要刷新
      loaded: false,
      isIosx: false,
      title: "",
      type: 0,
      cost_type: 0,
      searchActive: 0,
      navList: [
        { title: "全部", value: 0 },
        { title: "图文", value: 3 },
        { title: "视频", value: 2 },
        { title: "音频", value: 4 },
        { title: "专栏", value: 1 },
      ],
      dropdownOption: [
        { text: "全部", value: 0, check: true },
        { text: "免费", value: 1, check: false },
        { text: "不免费", value: -1, check: false },
      ],
      dropdownTitle: "收费类型",
      dataList: [],
      showType: true,
      searchUrl: "school/index/courses",
      isToken: false,
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      offsetTop: "77px",
    };
  },
  components: { CourseColum, CourseRow },
  mounted() {
    this.isIosx = this.isIphoneX();
  },
  activated() {
    if (this.needRefresh) {
      this.initData();
    }
    if (this.isToken) {
      if (this.isIosx) {
        this.offsetTop = "82px";
      } else {
        this.offsetTop = "77px";
      }
    } else {
      this.offsetTop = "48px";
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/school/search") {
      this.needRefresh = true;
    } else {
      this.needRefresh = false;
    }
    next();
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    // 页面初始化
    initData() {
      this.searchActive = 0;
      this.type = 0;
      this.page = 1;
      this.cost_type = 0;
      this.dataList = [];
      if (JSON.parse(sessionStorage.getItem("token"))) {
        this.isToken = true;
        this.searchUrl = "school/member/courses";
        this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      } else {
        this.isToken = false;
        this.searchUrl = "school/index/courses";
      }
      this.title = this.$route.query.searchTitle;
      this.getData();
    },
    // 展示类型切换
    changeShowType() {
      this.showType = !this.showType;
    },
    // 获得焦点
    getFocus() {
      this.prev();
    },
    // tab切换
    tabChange(name, title) {
      this.type = this.navList[name].value;
      this.onRefresh();
      this.loaded = false;
    },
    // 下拉筛选选择
    choice(value, title) {
      this.dropdownOption.forEach((item) => {
        item.check = false;
        if (item.value == value) {
          item.check = true;
        }
      });
      this.cost_type = value;
      this.dropdownTitle = title == "全部" ? "收费类型" : title;
      this.$refs.dropdown1.forEach((item) => {
        item.toggle(false);
      });
      this.onRefresh();
    },
    // 搜索课程
    toSearch() {
      this.onRefresh();
    },
    getData() {
      this.$api
        .get(this.searchUrl, {
          type: this.type, //类型：Number  必有字段  备注：0.全部,1.专栏 ,2.视频,3.图文,4.音频
          page: this.page, //类型：Number  必有字段  备注：1
          pageSize: this.pageSize, //类型：Number  必有字段  备注：10
          cost_type: this.cost_type, //类型：Number  必有字段  备注：0.全部，1:免费，2:付费，3:积分
          title: this.title,
        })
        .then((res) => {
          this.dataList = this.dataList.concat(res.list);
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.loading = true;
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
  },
};
</script>

<style>
.load {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.load img {
  width: 80px;
  height: 80px;
  margin: 200px 0 0;
}
.load p {
  font-size: 12px;
  color: #9ca1ad;
}
.searchResult {
  height: 100%;
  position: relative;
}
.searchResultNav {
  color: #404247;
  height: 22px;
  padding-top: 44px;
  padding-bottom: 11px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
}
.searchResultNav .navLeft {
  width: 24px;
  height: 24px;
  margin-left: 16px;
}
.searchResultNav .navMid {
  flex: 1;
  height: 33px;
  background: #f7f8fc;
  border-radius: 16px;
  margin: 0 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.searchResultNav .navMid img {
  width: 16px;
  height: 16px;
  margin-left: 16px;
}
.searchResultNav .navMid input {
  height: 33px;
}
.searchResultNav .navMid .van-cell {
  height: 33px;
  flex: 1;
  padding: 0;
  margin: 0 10px;
  background-color: #f7f8fc;
}
.searchResultNav .navRight {
  color: #6e727a;
  margin-right: 16px;
}

/* 搜索内容 */
.searchResult .van-tab {
  font-size: 15px;
}
.searchResult .van-tab--active {
  font-weight: 700;
}
.van-tabs__line {
  background: linear-gradient(90deg, #4e7df7 0%, #86b4fc 100%);
  bottom: 19px;
}
.searchResult .van-tab {
  flex: 1;
}
.searchResultMid {
  position: relative;
  top: 77px;
  left: 0;
}
.searchResultMid .seccontentTop {
  background-color: #ffffff;
  width: 100%;
  position: fixed;
  top: 121px;
  left: 0;
  z-index: 99;
}
.searchResultMid .seccontentTop > div {
  margin: 10px 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.searchResultMid .seccontentTop > div > div {
  width: 100px;
  margin-left: 16px;
}
.searchResultMid .seccontentTop .van-dropdown-menu__bar {
  height: 26px;
  box-shadow: none;
}
.searchResultMid .seccontentTop .van-dropdown-menu__item {
  background-color: rgba(78, 125, 247, 0.1);
  margin-right: 16px;
  border-radius: 20px;
}
.searchResultMid .seccontentTop .van-dropdown-menu__item:last-child {
  margin: 0;
}
.searchResultMid .seccontentTop .van-dropdown-menu__title {
  font-size: 13px;
  color: #9ca1ad;
}
.searchResultMid .seccontentTop > div > span {
  display: flex;
  align-items: center;
}
.searchResultMid .seccontentTop > div > span img {
  width: 16px;
  height: 16px;
}
/* 自定义下拉菜单 */
.dropdownMenu {
  color: #404247;
  font-size: 13px;
  padding: 24px 32px 0;
}
.dropdownItem {
  margin-bottom: 24px;
}
.dropdownItemCheck {
  color: #4e7df7;
}
/* 列表 */
.searchResultList {
  margin: 47px 16px 24px;
}

.searchResult .van-list__finished-text {
  margin-top: 48px;
}

/* 没有数据 */
.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noData img {
  width: 235px;
  height: 235px;
}
.noData p {
  font-size: 14px;
  color: #9ca1ad;
  margin-top: 24px;
}

.isIosx .searchResultNav {
  padding-top: 49px;
}
.isIosx .seccontentTop {
  top: 126px;
}
/* app外 */
.noAppNav .searchResultNav {
  padding-top: 15px !important;
}
.noAppNav .searchResultMid {
  top: 48px;
}
.noAppNav .seccontentTop {
  top: 92px;
}
</style>